module.exports = __webpack_public_path__ + "static/media/choithramsSimplyOrganic.540aa33a.png";